<template>
  <v-row justify="space-between" align="center" class="ma-0">
    <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
    <v-btn icon="mdi-plus" density="comfortable" @click="showModal = true" id="show-modal"></v-btn>
  </v-row>
  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-text>
          <v-table>
            <thead>
              <tr>
                <th class="table-heading-text">institution</th>
                <th class="table-heading-text text-center">account name</th>
                <th class="table-heading-text text-right">balance</th>
              </tr>
            </thead>
            <tbody>
              <tr class="remove-bottom-border" v-for="super_fund in super_funds.super_funds" :key="super_fund.id" @click="showEditModal(super_fund)">
                <td class="table-content-text text-left"> {{ super_fund.institution }}</td>
                <td class="table-content-text "> {{ super_fund.account_name }}</td>
                <td class="table-content-text text-right">{{ (super_fund.balance).toLocaleString() }}</td>
              </tr>
              <tr class="add-top-border">
                <td></td>
                <td></td>
                <td class="table-heading-text text-right">{{ Number(super_funds.total_balance).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  
  <!-- Modals -->
  <SuperFundsNewModalPopup :show="showModal" @close="showModal = false"></SuperFundsNewModalPopup><!-- add a new record -->
  <SuperFundsEditModalPopup :show="showEditModalToggle" :currentRow="selectedRow" @close="showEditModalToggle = false"></SuperFundsEditModalPopup> <!-- edit a record -->

</template>

<script>
import axios from 'axios';
import SuperFundsNewModalPopup from './modals/SuperFundsNewModalPopup.vue';
import SuperFundsEditModalPopup from './modals/SuperFundsEditModalPopup.vue';
import { mapState, mapMutations} from 'vuex';

export default {
  components: {
    SuperFundsNewModalPopup,
    SuperFundsEditModalPopup
  },
  data() {
    return {
      super_funds: [],
      showModal: false,
      showEditModalToggle: false,
      selectedRow: {}
    };
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
        {
          title: 'super funds',
          disabled: true,
          href: ''
        },
      ];
    },

  },
  async created() {
    this.getSuperFunds();
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    showEditModal(row){
      this.selectedRow=row;
      this.showEditModalToggle = true;
    },
    async getSuperFunds(){
      try {
      const response  = await axios.get("/superfunds/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
      this.super_funds = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load super funds' });
      }
    }
  }
  
};

</script>


<style scoped>

table tr{
  cursor: pointer;
}

.table-heading-text{
  font-size: 1.5rem;
  font-weight: 300 !important;
}

.table-content-text{
  font-size: 1.05rem;
  font-weight: 300 !important;
}

.remove-bottom-border td{
  border-bottom: none !important;
}

.add-top-border td{
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

</style>